module.exports = __webpack_public_path__ + "img/hideshow-on.618ce770.svg";